import "core-js/modules/es.function.name.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-b1b821c4"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "AppExpectations"
};
var _hoisted_2 = {
  key: 0,
  "class": "message__holder"
};
var _hoisted_3 = {
  "class": "message"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "max-width": "100vw",
      "position": "absolute",
      "top": "0px",
      "left": "0px"
    }
  }, [/*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "100vw",
    height: "auto",
    viewBox: "0 0 413 68",
    fill: "none"
  }, [/*#__PURE__*/_createElementVNode("path", {
    d: "M264.485 27.6455C354.892 20.6062 389.665 32.6292 413 44.5L413 -0.00012207L0 -0.000120029L0 65C95.007 77.9608 151.477 36.4445 264.485 27.6455Z",
    fill: "white",
    "fill-opacity": "0.08"
  })])], -1);
});
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "color": "#FFF",
      "text-align": "center",
      "text-shadow": "7px -2px 4px rgba(0, 0, 0, 0.25)",
      "font-family": "'Nunito Sans'",
      "font-size": "32px",
      "font-style": "normal",
      "font-weight": "700",
      "margin-top": "26px",
      "line-height": "27px"
    }
  }, " Explore AIVitars Available ", -1);
});
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "border-radius": "17px",
      "border": "1px solid rgba(255, 255, 255, 0.46)",
      "background": "rgba(255, 255, 255, 0.26)",
      "box-shadow": "7px 5px 10.7px 0px rgba(0, 0, 0, 0.25)",
      "text-align": "center",
      "text-shadow": "0px 4px 4px rgba(0, 0, 0, 0.25)",
      "color": "#fff",
      "width": "395px",
      "height": "66px",
      "flex-shrink": "0",
      "font-family": "Nunito Sans, sans-serif !important",
      "font-size": "24px",
      "font-style": "normal",
      "font-weight": "300",
      "margin-top": "15px",
      "line-height": "normal"
    }
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin-top": "5px"
    }
  }, "Scroll Through AIVitar Gallery"), /*#__PURE__*/_createElementVNode("div", {
    style: {
      "color": "#000",
      "text-align": "right",
      "font-family": "'Nunito Sans'",
      "font-size": "17px",
      "font-style": "normal",
      "margin-right": "35px",
      "font-weight": "300",
      "line-height": "normal"
    }
  }, "...then, Click To View")], -1);
});
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "color": "#fff",
      "font-family": "'Nunito Sans'",
      "font-size": "17px",
      "margin-top": "10px",
      "text-align": "center",
      "font-style": "normal",
      "font-weight": "600",
      "line-height": "normal"
    }
  }, [/*#__PURE__*/_createTextVNode(" Send Photos, Advanced Interactions and Realistic Voices Available With "), /*#__PURE__*/_createElementVNode("u", null, "ALL"), /*#__PURE__*/_createTextVNode(" AiVitars ")], -1);
});
var _hoisted_8 = {
  "class": "gallery__container"
};
var _hoisted_9 = {
  key: 0,
  "class": "square__nude"
};
var _hoisted_10 = ["onClick"];
var _hoisted_11 = {
  key: 0,
  "class": "square__nude-label-xxx"
};
var _hoisted_12 = {
  key: 1,
  "class": "square__nude-label"
};
var _hoisted_13 = ["src"];
var _hoisted_14 = ["src"];
var _hoisted_15 = {
  key: 2,
  "class": "square__highlight"
};
var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    "class": "square__highlight--green"
  }, "Video Conversations", -1);
});
var _hoisted_17 = {
  key: 3,
  "class": "square__highlight"
};
var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    "class": "square__highlight--green"
  }, "Animated", -1);
});
var _hoisted_19 = {
  key: 0,
  style: {
    "margin-bottom": "100px",
    "display": "block"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_IntroGalleryConfirmation = _resolveComponent("IntroGalleryConfirmation");
  var _component_ShowXrated = _resolveComponent("ShowXrated");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.message.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString($data.message), 1)])) : _createCommentVNode("", true), _hoisted_4, _hoisted_5, _ctx.$store.state.showGalleryConfirmation ? (_openBlock(), _createBlock(_component_IntroGalleryConfirmation, {
    key: 1
  })) : _createCommentVNode("", true), _hoisted_6, _hoisted_7, _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.avatarList, function (aivitar, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      "class": _normalizeClass({
        'square__gallery-item': true,
        'square__gallery-item--hidden': $options.checkHidden(aivitar)
      })
    }, [_createElementVNode("div", {
      "class": _normalizeClass({
        'square__container': true,
        'square__container--hidden': $options.checkHidden(aivitar)
      })
    }, [aivitar.isPro && _ctx.$store.state.introShowAsXRated == false ? (_openBlock(), _createElementBlock("div", _hoisted_9)) : _createCommentVNode("", true), _createElementVNode("div", {
      "class": "square",
      onClick: function onClick($event) {
        return $options.selectAvatar(aivitar);
      }
    }, [aivitar.XXX && _ctx.$store.state.appExpectations.romantic ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Can Send Nudes")) : _createCommentVNode("", true), aivitar.isPro && _ctx.$store.state.introShowAsXRated == false ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$store.state.proMembership || _ctx.$store.state.basicMembership ? 'Toggle To Remove Filter' : 'Unlock With Pro'), 1)) : _createCommentVNode("", true), _createElementVNode("img", {
      src: $options.getImage(aivitar),
      "class": _normalizeClass({
        'square__image': true,
        'square__image--blr': aivitar.isPro && _ctx.$store.state.introShowAsXRated == false
      })
    }, null, 10, _hoisted_13), _createElementVNode("img", {
      src: $options.getImageAnimated(aivitar),
      "class": _normalizeClass({
        'square__image': true,
        'square__image--blr': aivitar.isPro && _ctx.$store.state.introShowAsXRated == false
      })
    }, null, 10, _hoisted_14), aivitar.liveVideoThumbnail ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_hoisted_16, _createTextVNode(" Available!")])) : _createCommentVNode("", true), aivitar.animated ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_hoisted_18, _createTextVNode(" Image!")])) : _createCommentVNode("", true)], 8, _hoisted_10)], 2), _createElementVNode("div", {
      "class": _normalizeClass([{
        'square__label': true
      }, "square__label"])
    }, _toDisplayString(aivitar.name), 1), (aivitar.name === 'Sarah' || aivitar.name === 'Marcus') && _ctx.$store.state.appExpectations.romantic === true ? (_openBlock(), _createElementBlock("h1", _hoisted_19, " ... and " + _toDisplayString($options.calculateProAIVitars()) + " additional Pro Avatars", 1)) : _createCommentVNode("", true)], 2);
  }), 128))]), _ctx.$store.state.appExpectations.romantic ? (_openBlock(), _createBlock(_component_ShowXrated, {
    key: 2
  })) : _createCommentVNode("", true)]);
}